export default __webpack_public_path__ + "static/media/sac-logo.7776b610_NEW.8c670d26.svg";